import history from '../utils/history.js';

export default class HomePopup {
    constructor() {
        this.$homePopup = $('.close-storys');
    }

    homePopup() {
        const $storys = $('.map__storys-wrap');
        const $plus = $('.home-svg-wrap');
        const $cloud = $('.cloud');
        const $data = $('.map-pointer-marker');

        this.$homePopup.click(() => {
            $storys.fadeOut(300);
            $plus.css('right', '28px');
            $cloud.css('right', '96px');
            $data.removeAttr('data-current', 'current');

            $('body').removeClass('is-home-search-visible');

            history.set({
                ids: false
            });
        });
    }

    init() {
        this.homePopup();
    }
}
